import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui/dialog';

export const DesignerHeader: React.FC = () => (
  <header className="grid h-14 shrink-0 grid-cols-[1fr_auto_1fr] items-center border-b border-border bg-card px-4">
    <h1 className="col-start-2 truncate text-sm font-semibold tracking-[0.18em] text-foreground">
      DOOR DESIGNER
    </h1>
    <div className="col-start-3 justify-self-end">
      <Dialog>
        <DialogTrigger asChild>
          <Button type="button" variant="outline" size="sm" className="gap-1.5">
            <HelpCircle className="h-4 w-4" />
            Help
          </Button>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Door Designer help</DialogTitle>
            <DialogDescription>
              Work through Frame, Door Style, Colour, Glass, Furniture, and Review. The
              preview updates as you choose. Quote saving is not wired yet.
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </div>
  </header>
);
